var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path6, _circle1, _circle10, _circle11, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 144,
    viewBox: "0 0 285 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 41,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#006CFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8443 74.0855H26.6795L32.2436 88.61H39.2936L46.9804 68.6729L49.0726 63.1542L50.422 66.0955L54.2578 64.3823L49.5426 54.1484L39.1723 58.6968L40.9159 62.4871L43.9481 61.1529L41.0675 68.6123L36.0339 81.7116L31.3795 68.6578H23.7988L23.8443 74.0855Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 41,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#006CFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.844 74.0855H122.679L128.244 88.61H135.294L142.98 68.6729L145.073 63.1542L146.422 66.0955L150.258 64.3823L145.543 54.1484L135.172 58.6968L136.916 62.4871L139.948 61.1529L137.067 68.6123L132.034 81.7116L127.379 68.6578H119.799L119.844 74.0855Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 33,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#006CFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.055 74.3569H215.599L222.554 92.5125H231.367L240.975 67.5912L243.59 60.6928L245.277 64.3694L250.072 62.2279L244.178 49.4355L231.215 55.121L233.394 59.8589L237.185 58.1912L233.584 67.5153L227.292 83.8895L221.474 67.5722H211.998L212.055 74.3569Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 87,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 103L163.5 107L170.5 99",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 87,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 103L67.5 107L74.5 99",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 87,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 103,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 103,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 103,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 129,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 35,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 22.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 11.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 142.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 138.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 126L205.5 140",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 22.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 42.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175 13L186 27",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 10L249.5 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceCustom);
export default __webpack_public_path__ + "static/media/persistence-custom.5ee4c565897df2bb8e6f9febbd0b406d.svg";
export { ForwardRef as ReactComponent };